export default __webpack_public_path__ + "static/media/menu.61c1a697.png";